// Packages:
import styled, { keyframes } from 'styled-components'

// Exports:
export const Wrapper = styled.div`
  position: relative;
  width: 30%;
  height: 100%;
  box-shadow: rgba(136, 165, 191, 0.48) 2px 3px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
  background: #ffffff;
  padding: 0.5rem;
  max-height: 750px;
  border-radius: 4px;
  margin: 0 auto;
  color: #333333;
  display: flex;
  justify-content: center; /* Align children horizontally in the center */
  align-items: center; /* Align children vertically in the center */
`

const fadeInAndRiseUp = keyframes`
  from {
    filter: opacity(0);
    transform: translateY(-10px);
  }
  to {
    filter: opacity(1);
    transform: translateY(0);
  }
`

export const ReactionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    border-collapse: collapse;
    padding: 5px;
    text-align: left;
  }
`

export const Info = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; /* Align children vertically in the center */
  margin: 0 1rem; /* Add margin for spacing */
`

export const InfoTitle = styled.div`
  height: auto; /* Remove fixed height */
  font-size: 14px;
  padding-top: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  white-space: nowrap; 
  text-align: center; 
`;

export const InfoWrapper = styled.div`
  animation: ${ fadeInAndRiseUp } 1s ease;
  font-size: 14px;
  padding: 5px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center; /* Align children horizontally in the center */
`

